import { render } from "./PermissionPage.vue?vue&type=template&id=3cbb33ae&ts=true"
import script from "./PermissionPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PermissionPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/permission/PermissionPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cbb33ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cbb33ae', __exports__)) {
    api.reload('3cbb33ae', __exports__)
  }
  
  module.hot.accept("./PermissionPage.vue?vue&type=template&id=3cbb33ae&ts=true", () => {
    api.rerender('3cbb33ae', render)
  })

}


export default __exports__